// extracted by mini-css-extract-plugin
export var cv = "cv-module--cv--1lBcg";
export var cvTable = "cv-module--cvTable--3ceTj";
export var fadeInChildren = "cv-module--fadeInChildren--76dgl";
export var slideIn = "cv-module--slideIn--1cLhd";
export var fadeIn = "cv-module--fadeIn--2yTFk";
export var bgGradient = "cv-module--bgGradient--2cfXf";
export var borderColorStep = "cv-module--borderColorStep--3IgOT";